module.exports = __webpack_public_path__ + "img/logo-jnj-mark.34a8cac8.svg";